import React, { useEffect, useRef } from 'react';
import { Animated, TouchableOpacity } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { TextPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map, isUndefined as _isUndefined, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import BillingTestKeys from '../../../../Utils/BillingTestKeys.js';
import styles from '../BarChart.Styles';

function VerticalLabels({
  data,
  onBillBarPress,
  currentActiveIndex,
  getBillAnimatedStyle,
  theme,
  textStyle,
  lastMonthStyle,
  getCurentActiveIndex,
}) {
  const opacityAnimation = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(opacityAnimation, {
      toValue: 1,
      duration: 500,
      delay: 300,
      useNativeDriver: false,
    }).start();
  }, [opacityAnimation]);
  useEffect(() => {
    _isFunction(getCurentActiveIndex) && getCurentActiveIndex(currentActiveIndex);
  }, [currentActiveIndex]);


  return _map(data, (billsPerMonth, i) => {
    const isYearVisible =
      (i === 0 || (i !== 0 && data[i].data?.[0]?.year !== data[i - 1].data?.[0]?.year)) &&
      billsPerMonth?.data[0]?.monthNumber === '1';

    return (
      <Animated.View
        style={[
          { opacity: opacityAnimation },
          styles.billsPerMonthContainer(billsPerMonth.data?.length),
          getBillAnimatedStyle && getBillAnimatedStyle(i).marginRightAnimatedStyle,
          isYearVisible ? styles.yearMargin : {},
          { paddingHorizontal: 0 }
        ]}
        testID={`${BillingTestKeys.verticalLabelsView}${i}`}
        key={`VerticalLabels${i}`}
      >
        <TouchableOpacity
          onPress={() => onBillBarPress(i)}
          activeOpacity={1}
          disabled={billsPerMonth?.data.length === 0 || !billsPerMonth?.data}
          testID={BillingTestKeys.verticalLabelsBillBarBtn}
          style={{ alignItems: 'center', flex: 1 }}
        >
          <VFText
            style={[
              styles.verticalLabelsTextStyle(theme),
              !_isUndefined(currentActiveIndex) &&
              i !== currentActiveIndex &&
              styles.deactiveVerticalLabelsTextStyle(theme),
              !_isUndefined(currentActiveIndex) &&
              i === currentActiveIndex &&
              styles.activeVerticalLabelsTextStyle(theme),
              textStyle,
              i === data.length - 1 && lastMonthStyle,
            ]}
            i18nKey={billsPerMonth.shortMonth}
            numberOfLines={1}
            testKey={BillingTestKeys.verticalLabelBillDetailsShortMonth}
          />
        </TouchableOpacity>
      </Animated.View>
    );
  });
}
VerticalLabels.prototype = {
  data: PropTypes.array,
  theme: PropTypes.object,
  getCurentActiveIndex: PropTypes.func,
  currentActiveIndex: PropTypes.number,
  onBillBarPress: PropTypes.func,
  textStyle: TextPropTypes.style,
  lastMonthStyle: TextPropTypes.style,
};
export default withTheme(VerticalLabels);
